<template>

    <MenuIsoGrow/>

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Income</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callNewItem" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Add Item</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="grid">
                        &nbsp;
                    </div>

                    <div class="grid">
                        <div class="col-12 md:col-3">
                            <div class="card p-fluid">

                                <h3>Net Worth</h3>

                                <table class="w-full" :style="{ borderCollapse: 'collapse', tableLayout: 'auto' }">
                                    <thead>
                                    <tr>
                                        <th
                                            class="text-left font-semibold py-3 border-bottom-1 surface-border white-space-nowrap">
                                            Type of Holdings
                                        </th>
                                        <th
                                            class="text-right font-semibold py-3 border-bottom-1 surface-border white-space-nowrap px-3">
                                            Value
                                        </th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <tr>
                                        <td
                                            class="text-left py-3 border-bottom-1 surface-border white-space-nowrap">
                                            Assets
                                        </td>
                                        <td class="text-right py-3 border-bottom-1 surface-border">
                                            R {{
                                                formatAmount(100000)
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="text-left py-3 border-bottom-1 surface-border white-space-nowrap">
                                            Less : Liabilities
                                        </td>
                                        <td class="text-right py-3 border-bottom-1 surface-border">
                                            R {{
                                                formatAmount(20000)
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="text-left py-3 border-bottom-1 surface-border white-space-nowrap">
                                            <span class="font-semibold">Net Worth</span>
                                        </td>
                                        <td class="text-right py-3 border-bottom-1 surface-border">
                                                <span class="font-semibold">R {{
                                                        formatAmount(80000)
                                                    }}</span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="col-12 md:col-1">
                            <div class="card p-fluid">
                                &nbsp;
                            </div>
                        </div>

                        <div class="col-12 md:col-3">
                            <div class="card p-fluid">

                                <h3>Annual Income</h3>
                                <table class="w-full" :style="{ borderCollapse: 'collapse', tableLayout: 'auto' }">
                                    <thead>
                                    <tr>
                                        <th
                                            class="text-left font-semibold py-3 border-bottom-1 surface-border white-space-nowrap">
                                            Category
                                        </th>
                                        <th
                                            class="text-right font-semibold py-3 border-bottom-1 surface-border white-space-nowrap px-3">
                                            Value
                                        </th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <tr>
                                        <td
                                            class="text-left py-3 border-bottom-1 surface-border white-space-nowrap">
                                            Income
                                        </td>
                                        <td class="text-right py-3 border-bottom-1 surface-border">
                                            R {{
                                                formatAmount(40000)
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="text-left py-3 border-bottom-1 surface-border white-space-nowrap">
                                            Less : Expenses
                                        </td>
                                        <td class="text-right py-3 border-bottom-1 surface-border">
                                            R {{
                                                formatAmount(10000)
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="text-left py-3 border-bottom-1 surface-border white-space-nowrap">
                                            Less : Tax (Paid and Estimated)
                                        </td>
                                        <td class="text-right py-3 border-bottom-1 surface-border">
                                            R {{
                                                formatAmount(5000)
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="text-left py-3 border-bottom-1 surface-border white-space-nowrap">
                                            <span class="font-semibold">Total Disposable Income</span>
                                        </td>
                                        <td class="text-right py-3 border-bottom-1 surface-border">
                                                <span class="font-semibold">R {{
                                                        formatAmount(25000)
                                                    }}</span>
                                        </td>
                                    </tr>
                                    </tbody>

                                </table>
                            </div>
                        </div>

                        <div class="col-12 md:col-1">
                            <div class="card p-fluid">
                                &nbsp;
                            </div>
                        </div>

                        <div class="col-12 md:col-1">
                            <div class="card p-fluid">

                                <div class="col-span-12 xl:col-span-6">
                                    <div class="card flex flex-col items-center">
                                        <Chart type="doughnut" :data="pieDataNetWorth" :options="pieOptionsNetWorth"></Chart>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="col-12 md:col-1">
                            <div class="card p-fluid">
                                &nbsp;
                            </div>
                        </div>

                        <div class="col-12 md:col-1">
                            <div class="card p-fluid">

                                <div class="col-span-12 xl:col-span-6">
                                    <div class="card flex flex-col items-center">
                                        <Chart type="doughnut" :data="pieDataIncome" :options="pieOptionsIncome"></Chart>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div class="grid">
                        <div class="col-12 md:col-12">
                            <div class="card p-fluid">
                                &nbsp;
                            </div>
                        </div>
                    </div>

                    <div class="col-12 md:col-12">
                        <div class="card p-fluid">
                            <div class="p-grid">

                                <DataTable
                                    :value="holdings"
                                    lazy
                                    paginator
                                    :rows="lazyParams.rows"
                                    :first="lazyParams.first"
                                    :totalRecords="totalRecords"
                                    :loading="loading"
                                    :sortField="lazyParams.sortField"
                                    :sortOrder="lazyParams.sortOrder"
                                    :filterConstraints="lazyParams.filters"
                                    sortMode="single"
                                    :rowHover="true"
                                    :striped-rows="true"
                                    :reorderableColumns="true"
                                    responsiveLayout="scroll"
                                    filterDisplay="menu"
                                    :globalFilterFields="['id', 'name']"
                                    @page="onPage"
                                    @sort="onSort">

                                    <template #header>
                                        <div class="p-grid">
                                            <div class="grid">
                                                <div class="col-12 lg:col-2 p-2">
                                                    <Dropdown v-model="selectedType"
                                                              :options="standardTypes"
                                                              optionLabel="name" optionValue="code"
                                                              placeholder="Select a Type"
                                                              @update:modelValue="onToggleTypes"/>
                                                </div>
                                                <div class="col-12 lg:col-6 p-2">
                                                    <MultiSelect v-model="selectedColumns"
                                                                 :options="columnsFullList"
                                                                 optionLabel="header"
                                                                 optionValue="field"
                                                                 @change="onToggleColumns"
                                                                 display="chip"
                                                                 placeholder="Select Columns"
                                                                 :filter="true"
                                                                 filterPlaceholder="Search columns..."
                                                                 :virtualScrollerOptions="{ itemSize: 40 }"/>
                                                </div>

                                                <div class="col-12 lg:col-2 p-2">
                                                    <Button type="button" icon="pi pi-filter-slash" label="Clear Search"
                                                            class="p-button-outlined p-ml-2" @click="clearFilter()"/>
                                                </div>
                                                <div class="col-12 lg:col-2 p-2">
                                                    <Button type="button" icon="pi pi-replay"
                                                            label="Restore to Original View"
                                                            class="p-button-outlined" @click="restoreToOriginal()"/>
                                                </div>
                                            </div>

                                            <div class="p-col-12 p-md-2">
                                                <span class="p-input-icon-left">
                                                    <i class="pi pi-search"/>
                                                    <InputText v-model="filters['global'].value"
                                                               placeholder="Keyword Search on Keyword Search on ID or Name (Please press enter to search)"
                                                               style="width: 100%"
                                                               @keyup.enter="onSearch"/>

                                                </span>
                                            </div>
                                        </div>
                                    </template>

                                    <template #empty>
                                        No holdings found.
                                    </template>

                                    <template #loading>
                                        Loading holdings. Please wait.
                                    </template>

                                    <Column header="Actions" :exportable="false"
                                            style="max-width: 130px; min-width: 100px;">
                                        <template #body="{ data }">
                                            <div
                                                style="max-width: 130px; min-width: 100px; display: flex; flex-wrap: wrap; justify-content: flex-start; align-items: center;">

                                                <Button v-tooltip.top="'Update'"
                                                        icon="pi pi-pencil"
                                                        class="p-button-rounded p-button-success m-1"
                                                        :loading="loading"
                                                        @click="callUpdateTask(data)"/>

                                                <Button v-tooltip.top="'Delete'"
                                                        icon="pi pi-trash"
                                                        class="p-button-rounded p-button-danger m-1"
                                                        :loading="loading"
                                                        @click="callDeleteTask(data)"/>
                                            </div>
                                        </template>
                                    </Column>

                                    <Column v-for="column in columnsForDataTable" :key="column.field"
                                            :field="column.field"
                                            :sortable="column.sortable" :style="column.style"
                                            :frozen="column.frozen || false">

                                        <template #header>
                                            <span>
                                                {{ column.header }}
                                            </span>
                                        </template>

                                        <template #body="{ data }">
                                            <span v-if="column.field === 'status'">
                                                <span v-if="data[column.field] === 'I'"
                                                      :class="'status-badge status-' + data[column.field]">Inactive</span>
                                                <span v-if="data[column.field] === 'A'"
                                                      :class="'status-badge status-' + data[column.field]">Active</span>
                                            </span>

                                            <span v-else-if="column.field === 'type'">
                                                <span v-if="data[column.field] === 'N01'"
                                                      :class="'type-badge status-' + data[column.field]">Assets</span>
                                                <span v-if="data[column.field] === 'N02'"
                                                      :class="'type-badge status-' + data[column.field]">Liabilities</span>
                                                <span v-if="data[column.field] === 'N03'"
                                                      :class="'type-badge status-' + data[column.field]">Income</span>
                                                <span v-if="data[column.field] === 'N04'"
                                                      :class="'type-badge status-' + data[column.field]">Expenses</span>
                                                <span v-if="data[column.field] === 'N05'"
                                                      :class="'type-badge status-' + data[column.field]">Tax</span>
                                            </span>

                                            <span v-else-if="column.field === 'cost'">
                                                {{ formatAmount(data["cost"]) }}
                                            </span>

                                            <span v-else-if="column.field === 'value'">
                                                {{ formatAmount(data["value"]) }}
                                            </span>

                                            <span v-else>
                                                {{ data[column.field] }}
                                            </span>
                                        </template>
                                    </Column>

                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Create New Holdings Item</h3>

                    <div class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="newHoldings.type" :options="standardTypes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="newHoldings.name" required="true"/>
                    </div>

                    <div v-if="(newHoldings.type === 'N01') || (newHoldings.type === 'N03')" class="field">
                        <label for="value">Value</label>
                        <InputNumber id="value" v-model="newHoldings.value" :required="true"/>
                    </div>

                    <div v-if="(newHoldings.type === 'N02') || (newHoldings.type === 'N04') || (newHoldings.type === 'N05')"
                         class="field">
                        <label for="cost">Cost</label>
                        <InputNumber id="cost" v-model="newHoldings.cost" :required="true"/>
                    </div>

                    <Button label="Create" :disabled="!canCreateHoldings" class="mr-2 mb-2" @click="createHoldings"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="loading" @click="callReset"></Button>

                </div>
            </div>
        </div>

    </div>

    <IsoGrowFooter/>

</template>

<script>
import IsoGrowFooter from "@/components/isogrow/IsoGrowFooter.vue";
import MenuIsoGrow from "@/components/isogrow/MenuIsoGrow.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import numeral from "numeral";
import Chart from "primevue/chart";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import HoldingsService from "@/service/HoldingsService";

export default {
    components: {
        Chart,
        MenuIsoGrow,
        IsoGrowFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[PmOverviewDashboard][mounted] System is active.");
            console.log("[PmOverviewDashboard][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] System is NOT active.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[PmOverviewDashboard][mounted] User is NOT defined.");
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        try {
            if (!this.userStore.user) {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            }

            this.profile = this.userStore.user;

        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] No user data found.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push('login');
        }

        this.selectedColumns = this.columnsFullList.map(column => column.field);

        await this.loadData();

        const documentStyle = getComputedStyle(document.documentElement);

        const colorKeysNetWorth = [
            {key: '--p-indigo-500', fallback: '#3F51B5'},
            {key: '--p-purple-500', fallback: '#9C27B0'},
            {key: '--p-teal-500', fallback: '#009688'},
            {key: '--p-orange-500', fallback: '#FF9800'},
            {key: '--p-red-500', fallback: '#F44336'},
            {key: '--p-blue-500', fallback: '#2196F3'},
        ];

        // Get colors from CSS variables with fallbacks
        const backgroundColorsNetWorth = colorKeysNetWorth.map(color => documentStyle.getPropertyValue(color.key) || color.fallback);

        // Generate hover colors (lighter shades)
        const hoverColorKeysNetWorth = colorKeysNetWorth.map(color => color.key.replace('500', '400'));
        const hoverBackgroundColorsNetWorth = hoverColorKeysNetWorth.map((key, index) =>
            documentStyle.getPropertyValue(key) || this.lightenColor(backgroundColorsNetWorth[index], 20)
        );

        const textColorNetWorth = documentStyle.getPropertyValue('--text-color') || '#333333';  // Fallback to black if not found

        // console.log("[TrackData][mounted] this.resultsSector = ", this.resultsSector);

        const testAssets = 100000;
        const testLiabilities = 20000;

        // You can create a static array for your test pie chart data
        const pieChartDataNetWorth = [
            { category: 'Assets', value: testAssets },
            { category: 'Liabilities', value: testLiabilities }
        ];

        // Define your labels and data based on the test data
        const labelsNetWorth = pieChartDataNetWorth.map(item => item.category);
        const dataValuesNetWorth = pieChartDataNetWorth.map(item => item.value);

        this.pieDataNetWorth = {
            labels: labelsNetWorth,
            datasets: [
                {
                    data: dataValuesNetWorth,
                    backgroundColor: backgroundColorsNetWorth,
                    hoverBackgroundColor: hoverBackgroundColorsNetWorth
                }
            ]
        };

        this.pieOptionsNetWorth = {
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        color: textColorNetWorth
                    }
                }
            }
        };


        const colorKeysIncome = [
            {key: '--p-green-500', fallback: '#4CAF50'},
            {key: '--p-cyan-500', fallback: '#00BCD4'},
            {key: '--p-pink-500', fallback: '#E91E63'},
            {key: '--p-lime-500', fallback: '#CDDC39'},
            {key: '--p-amber-500', fallback: '#FFC107'},
            {key: '--p-deep-orange-500', fallback: '#FF5722'},
            {key: '--p-light-blue-500', fallback: '#03A9F4'},
            {key: '--p-light-green-500', fallback: '#8BC34A'},
            {key: '--p-deep-purple-500', fallback: '#673AB7'},
            {key: '--p-brown-500', fallback: '#795548'},
            {key: '--p-gray-500', fallback: '#9E9E9E'},
            {key: '--p-blue-gray-500', fallback: '#607D8B'},
            {key: '--p-indigo-300', fallback: '#7986CB'}
        ];

        // Get colors from CSS variables with fallbacks
        const backgroundColorsIncome = colorKeysIncome.map(color => documentStyle.getPropertyValue(color.key) || color.fallback);

        // Generate hover colors (lighter shades)
        const hoverColorKeysIncome = colorKeysIncome.map(color => color.key.replace('500', '400'));
        const hoverBackgroundColorsIncome = hoverColorKeysIncome.map((key, index) =>
            documentStyle.getPropertyValue(key) || this.lightenColor(backgroundColorsIncome[index], 20)
        );

        const textColorIncome = documentStyle.getPropertyValue('--text-color') || '#333333';  // Fallback to black if not found


        const testIncome = 40000;
        const testExpenses = 10000;
        const testTax = 5000;

        // You can create a static array for your test pie chart data
        const pieChartDataIncome = [
            { category: 'Income', value: testIncome },
            { category: 'Expenses', value: testExpenses },
            { category: 'Tax', value: testTax },
        ];

        // Define your labels and data based on the test data
        const labelsIncome = pieChartDataIncome.map(item => item.category);
        const dataValuesIncome = pieChartDataIncome.map(item => item.value);

        this.pieDataIncome = {
            labels: labelsIncome,
            datasets: [
                {
                    data: dataValuesIncome,
                    backgroundColor: backgroundColorsIncome,
                    hoverBackgroundColor: hoverBackgroundColorsIncome
                }
            ]
        };

        this.pieOptionsIncome = {
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        color: textColorIncome
                    }
                }
            }
        };

        // const pieChartData = this.holdings.filter(item => item.cost > 0);
        //
        // // Update pie chart data
        // this.pieData = {
        //     labels: pieChartData.map(item => item.category),  // Sector names for labels
        //     datasets: [
        //         {
        //             data: pieChartData.map(item => item.value),  // Market values
        //             backgroundColor: backgroundColors,
        //             hoverBackgroundColor: hoverBackgroundColors
        //         }
        //     ]
        // };
        //
        // this.pieOptions = {
        //     plugins: {
        //         legend: {
        //             labels: {
        //                 usePointStyle: true,
        //                 color: textColor
        //             }
        //         }
        //     }
        // };
    },
    data() {

        return {
            activeTab: 1,
            items: [
                {
                    label: 'Options',
                    items: [
                        {label: 'Add New', icon: 'pi pi-fw pi-plus'},
                        {label: 'Search', icon: 'pi pi-fw pi-search'}
                    ]
                }
            ],
            date: new Date(),
            monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            profile: {},
            totalRecords: 0,
            loading: false,
            lazyParams: {
                first: 0,
                rows: 20,
                sortField: null,
                sortOrder: null,
                status: {},
                category: {},
                type: {}
            },
            existingHoldings: {},
            newHoldings: {},
            holdings: null,
            confirmationResponse: 'N',
            selectedColumns: [],
            selectedCategory: null,
            selectedType: null,
            pieDataNetWorth: {},
            pieOptionsNetWorth: {},
            pieDataIncome: {},
            pieOptionsIncome: {},
            filters: {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'id': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'name': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            },
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            columnsFullList: [
                {field: 'type', header: 'Type', sortable: true, style: 'max-width: 300px; min-width: 250px'},
                {field: 'name', header: 'Name', sortable: true, style: 'max-width: 250px; min-width: 200px'},
                {field: 'cost', header: 'Cost', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'value', header: 'Value', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'annualIncome', header: 'Annual Income', sortable: true, style: 'max-width: 100px; min-width: 50px'},
                {field: 'status', header: 'Status', sortable: true, style: 'max-width: 200px; min-width: 150px'}
            ],
            standardTypes: [
                {name: 'Assets', code: 'N01'},
                {name: 'Liabilities', code: 'N02'},
                {name: 'Income', code: 'N03'},
                {name: 'Expenses', code: 'N04'},
                {name: 'Tax', code: 'N05'}
            ]
        }
    },
    computed: {
        columnsForDataTable() {
            if (!this.selectedColumns || !Array.isArray(this.selectedColumns)) {
                return []; // Defensive check: return empty array if selectedColumns is not an array
            }
            return this.columnsFullList.filter(column => this.selectedColumns.includes(column.field));
        },
        canCreateHoldings() {
            return (
                this.newHoldings.name &&
                this.newHoldings.type
            );
        },
    },
    methods: {
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'id': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'name': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        callReset() {
            this.activeTab = 1;
        },
        async loadData() {
            this.loading = true;
            try {
                console.log("[NetWorth][loadData] Fetching data with params:", this.lazyParams,
                    "Search:", this.filters['global']?.value);

                const response = await HoldingsService.getHoldingsForCompany(
                    this.profile.companyId,
                    this.lazyParams,
                    this.filters['global']?.value || '',
                    this.selectedStatus,
                    this.selectedCategory,
                    this.selectedType);

                console.log("[NetWorth][loadData] API Response:", response);
                console.log("[NetWorth][loadData] response.data.content:", response.data?.content);
                console.log("[NetWorth][loadData] response.data.totalElements:", response.data?.totalElements);

                this.holdings = Array.isArray(response.data.content) ? response.data.content : [];

                this.totalRecords = response.data?.totalElements || 0;

            } catch (error) {
                console.error("[NetWorth][loadData] Error loading holdings:", error);
                this.holdings = [];
                this.totalRecords = 0;
            }
            this.loading = false;
        },
        onPage(event) {
            this.lazyParams.first = event.first;
            this.lazyParams.rows = event.rows;
            this.loadData();
        },
        onSort(event) {
            if (event.sortField) {
                this.lazyParams.sortField = event.sortField;
                this.lazyParams.sortOrder = event.sortOrder;
            } else {
                this.lazyParams.sortField = null;
                this.lazyParams.sortOrder = null;
            }
            this.loadData();
        },
        onSearch() {
            console.log("[NetWorth][onSearch] Filters = ", this.filters);
            this.lazyParams.first = 0;
            this.loadData();
        },
        async onToggleTypes() {
            await this.loadData();
        },
        onToggleColumns(event) {
            this.selectedColumns = event.value;
        },
        clearFilter() {
            // this.initFilters();
            this.selectedStatus = "I";
            this.selectedCategory = null;
            this.selectedType = null;
            this.lazyParams.filters = {};
            this.lazyParams.first = 0;
            this.loadData();
        },
        async restoreToOriginal() {
            this.$router.go(0);
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return 0;
            }
        },
        lightenColor(color, percent) {
            let num = parseInt(color.slice(1), 16);
            let amt = Math.round(2.55 * percent);
            let r = (num >> 16) + amt;
            let g = ((num >> 8) & 0x00FF) + amt;
            let b = (num & 0x0000FF) + amt;
            return `#${(0x1000000 + (r < 255 ? r : 255) * 0x10000 + (g < 255 ? g : 255) * 0x100 + (b < 255 ? b : 255)).toString(16).slice(1).toUpperCase()}`;
        },
        callNewItem() {
            this.newHoldings = {
                category: 'N',
                type: 'N01',
                cost: 0.0,
                value: 0.0,
                annualIncome: 0.0,
                fees: 0.0,
                status: 'A'
            };

            this.activeTab = 2;
        },
        async createHoldings() {
            this.loading = true;

            if (this.newHoldings.type) {

                try {

                    var newHoldingsDto = {
                        companyId: this.profile.companyId,
                        name: this.newHoldings.name,
                        category: this.newHoldings.category,
                        type: this.newHoldings.type,
                        cost: this.newHoldings.cost,
                        value: this.newHoldings.value,
                        status: 'A'
                    };

                    console.log('[NetWorth][createHoldings] newTrackDataDto = ', newHoldingsDto);

                    const response = await HoldingsService.createHoldings(this.profile.companyId, newHoldingsDto);
                    console.log('[NetWorth][createHoldings] Response = ', response);

                    this.loadData();

                    // this.calculateTrackSummary();

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created holdings info',
                        life: 3000
                    });
                } catch (error) {
                    console.error('[NetWorth][createHoldings] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create holdings info. Please try again.',
                        life: 3000
                    });
                }
            }

            this.newHoldings = {};
            this.activeTab = 1;
            this.loading = false;

        },
        previousDate() {
            this.date.setDate(this.date.getDate() - 1);
            this.date = new Date(this.date);
        },

        nextDate() {
            this.date.setDate(this.date.getDate() + 1);
            this.date = new Date(this.date);
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
